import { Tab, Tabs } from "@blueprintjs/core";
import { Page } from "modules/common/components/page/Page";
import { routes } from "modules/common/routes";
import { menuItems } from "modules/root/components/menu/MainMenu";
import React, { useCallback, type JSX } from "react";
import { useLocation } from "react-router";
import styles from "./SchedulesTabsPage.module.scss";
import { useStableNavigate } from "modules/common/components/routing/useStableNavigate";

const menu = menuItems();

interface SchedulesTabsPageProps {
    projectPlanPanel: JSX.Element | null;
    workloadPanel: JSX.Element | null;
}

/**
 * Раздел «Графики»: вкладки дублируют подпункты меню, как в «Управлении организацией»
 * и «Отчётах». Идентификатор вкладки — её маршрут, переключение это обычная навигация.
 */
export const SchedulesTabsPage: React.FC<SchedulesTabsPageProps> = (props) => {
    const { projectPlanPanel, workloadPanel } = props;
    const location = useLocation();
    const navigate = useStableNavigate();

    const onChange = useCallback((tabId: string) => navigate(tabId), [navigate]);

    return (
        <Page>
            <Tabs
                className={`${styles.tabs} planr-tabs-navigation`}
                id="SchedulesPage"
                selectedTabId={getTabId(location.pathname)}
                renderActiveTabPanelOnly={true}
                onChange={onChange}
            >
                {projectPlanPanel && (
                    <Tab
                        className="timesheet"
                        id={routes.schedules.projectPlan}
                        title={menu.schedules.nested.projectPlan.label}
                        panel={projectPlanPanel}
                    />
                )}

                {workloadPanel && (
                    <Tab
                        className="timesheet"
                        id={routes.schedules.workload}
                        title={menu.schedules.nested.workload.label}
                        panel={workloadPanel}
                    />
                )}
            </Tabs>
        </Page>
    );
};

const getTabId = (pathname: string) => {
    if (pathname.includes(routes.schedules.workload)) {
        return routes.schedules.workload;
    }

    if (pathname.includes(routes.schedules.projectPlan)) {
        return routes.schedules.projectPlan;
    }

    return "";
};

